export class RelativeRadius {
    constructor(
        private maxRadius: number,
        private pointRadius: number
    ) {}

    public radius(): number {
        return this.maxRadius * this.pointRadius;
    }
} 